import React from 'react';

import {DisabledSubscriptionEnforcement} from '../components/DisabledSubscriptionEnforcement';
import {EndOfTrialEnforcement} from '../components/EndOfTrialEnforcement';
import {ExpiredSubscriptionEnforcement} from '../components/ExpiredSubscriptionEnforcement';
import {ExpiringSubscriptionNudgeBar} from '../components/ExpiringSubscriptionNudgeBar';
import {BlockedRegionBannerGlobalList} from '../components/GlobalBanners/BlockedRegionBanners/BlockedRegionBanner';
import {InferenceExceededLimitBannerGlobalList} from '../components/GlobalBanners/InferenceEnforcementBanners/InferenceExceededLimitBanner';
import {NvidiaLinkedAccountBannerGlobal} from '../components/GlobalBanners/NvidiaLinkedAccountBanners/NvidiaLinkedAccountBanner';
import {SandboxesEnforcementBannerGlobalList} from '../components/GlobalBanners/SandboxesEnforcementBanners/SandboxesEnforcementBanner';
import {WeaveApproachingLimitBannerGlobalList} from '../components/GlobalBanners/WeaveEnforcementBanners/WeaveApproachingLimitBanner';
import {WeaveExceededLimitBannerGlobalList} from '../components/GlobalBanners/WeaveEnforcementBanners/WeaveExceededLimitBanner';
import {WeaveTrialBannerGlobalList} from '../components/GlobalBanners/WeaveEnforcementBanners/WeaveTrialBanner';
import {GetLicenseNudgeBar} from '../components/LocalLicenseGetNudge';
import LocalLicenseNudgeBar from '../components/LocalLicenseNudgeBar';
import LocalNudgeBar from '../components/LocalNudgeBar';
import MessageOfTheDay from '../components/MessageOfTheDay';
import TrialNudgeBar from '../components/TrialNudgeBar';
import {UserWithNoOrgEnforcement} from '../components/UserWithNoOrgEnforcement';
import {envIsServerDeployment} from '../config';
import {DisabledSubscriptionWarningBanner} from '../pages/Billing/AccountSettings/WarningBanner/DisabledSubscriptionWarningBanner';
import {ServerBanners} from '../pages/Billing/AccountSettings/WarningBanner/DismissibleBanner';
import {PaymentFailedBanner} from '../pages/Billing/AccountSettings/WarningBanner/PaymentFailedBanner';
import {PersonalEntityDisabledBanner} from '../pages/Billing/AccountSettings/WarningBanner/PersonalEntityDisabledBanner';
import {UserLockdownWarningBanner} from '../pages/Billing/AccountSettings/WarningBanner/UserLockdownBanners/UserLockdownWarningBanner/UserLockdownWarningBanner';
import {useViewer} from '../state/viewer/hooks';
import {ReachingResourceLimitWarningBannerGlobalList} from './../components/GlobalBanners/StorageEnforcementBanners/ReachingResourceLimitWarningBanner';
import {ResourceSubscriptionLimitExceededWarningBannerGlobalList} from './../components/GlobalBanners/StorageEnforcementBanners/ResourceSubscriptionLimitExceededWarningBanner';

const MaybeLocalNudgeBar: React.FC = () => {
  const viewer = useViewer();
  return envIsServerDeployment && viewer != null ? <LocalNudgeBar /> : <></>;
};

export const AppBanners = () => {
  return (
    <div style={{gridArea: 'banner'}}>
      <MessageOfTheDay />
      {envIsServerDeployment && <GetLicenseNudgeBar />}
      {envIsServerDeployment && <LocalLicenseNudgeBar />}
      <MaybeLocalNudgeBar />
      {!envIsServerDeployment && <ExpiringSubscriptionNudgeBar />}
      {!envIsServerDeployment && <ExpiredSubscriptionEnforcement />}
      {!envIsServerDeployment && <DisabledSubscriptionEnforcement />}
      {!envIsServerDeployment && <TrialNudgeBar />}
      {!envIsServerDeployment && <BlockedRegionBannerGlobalList />}
      {!envIsServerDeployment && <UserLockdownWarningBanner />}
      {envIsServerDeployment && <PersonalEntityDisabledBanner />}
      {!envIsServerDeployment && (
        <ReachingResourceLimitWarningBannerGlobalList />
      )}
      {!envIsServerDeployment && (
        <ResourceSubscriptionLimitExceededWarningBannerGlobalList />
      )}
      {!envIsServerDeployment && <DisabledSubscriptionWarningBanner />}
      {!envIsServerDeployment && <PaymentFailedBanner />}
      {!envIsServerDeployment && <WeaveApproachingLimitBannerGlobalList />}
      {!envIsServerDeployment && <WeaveExceededLimitBannerGlobalList />}
      {!envIsServerDeployment && <WeaveTrialBannerGlobalList />}
      {!envIsServerDeployment && <InferenceExceededLimitBannerGlobalList />}
      {!envIsServerDeployment && <SandboxesEnforcementBannerGlobalList />}
      <ServerBanners />
      {!envIsServerDeployment && <NvidiaLinkedAccountBannerGlobal />}
      {!envIsServerDeployment && <EndOfTrialEnforcement />}
      {!envIsServerDeployment && <UserWithNoOrgEnforcement />}
    </div>
  );
};
